import {
  CenterBig,
  LeftBig,
  LeftSmall,
  RightBig,
  RightSmall,
} from 'components/Annotationen'
import { CenterSmall, Circle } from 'components/Annotationen/Annotationen'
import styled from 'styled-components'
import { useWindowSize } from 'usehooks-ts'
import { Probability_Desktop } from './ChartDesktop'
import { Probability_Mobile } from './ChartMobile'

const annos_de = [
  <LeftBig style={{ left: '0%', top: '2%' }}>
    <b>Äpfel</b>
  </LeftBig>,

  <RightBig style={{ right: '0%', top: '2%' }}>
    <b>Birnen</b>
  </RightBig>,
  <CenterSmall style={{ left: '50%', top: '85%' }}>50%</CenterSmall>,
  <RightSmall style={{ right: '39%', top: '85%' }}>95%</RightSmall>,
  <RightSmall style={{ right: '0%', top: '85%' }}>100%</RightSmall>,
  <LeftSmall style={{ left: '0%', top: '85%' }}>100%</LeftSmall>,
  <LeftSmall style={{ left: '40%', top: '85%' }}>95%</LeftSmall>,
  <CenterSmall
    style={{
      left: '50%',
      bottom: '77%',
      color: 'var(--red-bright-1)',
      maxWidth: '110px',
      minWidth: 'unset',
    }}
  >
    Hier besteht ein höheres Risiko, dass der Computer falsch entscheidet.
  </CenterSmall>,
  <CenterBig style={{ left: '50%', top: '94%' }}>
    <b>Sicherheit der Prognose</b>
  </CenterBig>,
  // <Circle style={{ left: '50%', top: '50%' }} />,
]
const annos_de_mob = [
  <RightBig style={{ right: '0%', top: '24%' }}>
    <b>Äpfel</b>
  </RightBig>,

  <RightBig style={{ right: '0%', top: '73%' }}>
    <b>Birnen</b>
  </RightBig>,
  <RightSmall style={{ right: '80%', top: '48%' }}>50%</RightSmall>,
  <RightSmall style={{ right: '80%', top: '2%' }}>100%</RightSmall>,
  <RightSmall style={{ right: '80%', top: '39%' }}>95%</RightSmall>,
  <RightSmall style={{ right: '80%', top: '57%' }}>95%</RightSmall>,
  <RightSmall style={{ right: '80%', top: '95%' }}>100%</RightSmall>,
  <RightSmall
    style={{ right: '80%', top: '25%', maxWidth: '90px', minWidth: 'unset' }}
  >
    <b>Sicherheit der Prognose</b>
  </RightSmall>,
  <LeftSmall
    style={{
      left: '77%',
      bottom: '41%',
      color: 'var(--red-bright-1)',
      maxWidth: '100px',
      minWidth: 'unset',
      backgroundColor: 'var(--site-background)',
    }}
  >
    Hier besteht ein höheres Risiko, dass der Computer falsch entscheidet.
  </LeftSmall>,

]

export const Probability = () => {
  const { width, height } = useWindowSize()
  const annos = width >= 712 ? annos_de : annos_de_mob
  return (
    <StyledProbability>
      <Title>Wahrscheinlichkeit für das Eintreten des richtigen Ergebnisses</Title>
      {width >= 712 && <Probability_Desktop annotations={annos} />}
      {width < 712 && <Probability_Mobile annotations={annos} />}
    </StyledProbability>
  )
}
const StyledProbability = styled.div`
  margin-bottom: 60px;
`
const Title = styled.h3`
  font-family: var(--font-sans-serif);
  font-size: 18px;
  font-weight: 700;
  margin-bottom:30px;
  line-height:1.3em
`